import { useCallback, useState } from 'react';

//services
import { getCertificates } from 'services/sessions';

//interfaces
import { ICertificateItem } from 'services/interfaces/IExam';

export const useGetCertificates = () => {
  const [certificates, setCertificates] = useState<ICertificateItem[]>([]);

  const handleGetCertificates = useCallback(async (userId: string | number) => {
    try {
      const resp = await getCertificates(userId);
      if (resp) setCertificates(resp);
    } catch (e) {
      console.log(e);
    }
  }, []);

  return { certificates, handleGetCertificates };
};
